interface FileCsvProps {
  className?: string;
  size?: number;
}

export const FileCsv = ({ className = '', size = 40 }: FileCsvProps) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      {/* Document base */}
      <path
        d='M9 0h16l6 6v30a4 4 0 01-4 4H9a4 4 0 01-4-4V4a4 4 0 014-4z'
        fill='#F2F4F7'
      />
      {/* Folded corner */}
      <path d='M25 0l6 6h-6V0z' fill='#D0D5DD' />
      {/* CSV badge */}
      <rect x='13' y='18' width='14' height='10' rx='1.5' fill='#17B26A' />
      <text
        x='20'
        y='25.5'
        fontSize='6'
        fontWeight='600'
        fill='white'
        textAnchor='middle'
        fontFamily='Inter, sans-serif'
      >
        CSV
      </text>
    </svg>
  );
};
